<template>
    <div class="priority-list-page">

        <v-container grid-list-md class="no-padding-top">
            <v-layout row wrap>
                <v-flex v-if="questionPriorityList && questionPriorityList.questions"
                        v-for="question in questionPriorityList.questions"
                        :ref="'vFlexQuestionRef_' + question.code"
                        :id="'Q_' + question.code"
                        :key="question.code"
                        @click="selectSymptom(question)"
                        class="symptom-priority question-priority"
                        :class="{
                            'selected-symptom':(question.code === symptomCode), 'symptom-response':(question.providedAnswer !== null ),
                            'panel-highlighted': shortcutNav.isKeyboardNav === true && shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'QUESTIONS_PANEL' && shortcutNav.crtQuestion === question.code
                        }"
                        sm12 md12 lg12
                >
                    <div>
                        <div>
                            <div class="color-headings-text">
                                <span v-if="question.type=== 'START'">
                                    {{text('db.product.PROD_TITLE_START')}}:
                                </span>
                                <span v-if="question.type=== 'GENERAL'">
                                    {{text('db.product.PROD_TITLE_GEN')}}:
                                </span>
                                <span :id="'Q_NAME_' + question.code">{{question.name}}</span>
                           </div>
                            <div class="symptom-text">
                                <span :id="'Q_TEXT_' + question.code"> {{question.text}}</span>
                            </div>
                        </div>

                        <v-layout :ref="'vLayoutQuestion_' + question.code + '_AnswerListPanelRef'" row wrap class="
                        symptoms-list">
                            <div v-for="answer in question.answers"
                                 :key="answer.code"
                                 :ref="'divAnswerRef_' + answer.code"
                                 class="answers"
                            >

                                <v-btn-toggle
                                    class="transparent"
                                    :class="{'button-highlighted': shortcutNav.isKeyboardNav === true
                                                                   && shortcutNav.isPanelHighlight === false
                                                                   && shortcutNav.crtPanel === 'QUESTIONS_PANEL'
                                                                   && shortcutNav.crtAnswer === answer.code}"
                                >

                                    <v-btn
                                        @click="handleChangeAnswer(answer.code, question.code, question.answeredByVitalParam, $event)"
                                        :value="answer.code"
                                        :ref="'vBtn_' + question.code + '_' + answer.code"
                                        :id="'A_' + answer.code"
                                        :class="{'active':(question.providedAnswer === answer.code),  'active-symptom': isActive }"
                                    >{{answer.text}}
                                    </v-btn>
                                </v-btn-toggle>

                            </div>
                        </v-layout>

                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';

export default {

        name: "QuestionsPriorityList",

        data () {
            return {
                isActive: false
            }
        },

        computed: {
            ...mapGetters({
                questionPriorityList: 'AssessmentStartStore/getQuestionPriorityList',
                symptomDescription: 'SymptomsQuestionsStore/getSymptomDescription',
                symptomCode: 'SymptomsQuestionsStore/getSymptomCode',
                answerCode: 'SymptomsQuestionsStore/getAnswerCode',
                getSelectedLang: 'TranslationStore/getSelectedLang',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),

            navGetCrtQuestion() {
                return this.shortcutNav.crtQuestion;
            }
        },

        props: ["shortcutNav"],

        watch: {

            navGetCrtQuestion(newVal, oldVal) {

                if (this.shortcutNav.crtQuestion === null) {
                    return;
                }

                let questionIdx = this.questionPriorityList.questions.findIndex((currentQuestion) => {
                    return this.shortcutNav.crtQuestion === currentQuestion.code;
                });

                if (questionIdx < 0) {
                    return;
                }

                let currentQuestion = this.questionPriorityList.questions[questionIdx];
                // If the current question was pre-answered from VitalParametersDropdown the selectSymptom function was already called by the click event
                // This allows the VitalParameters to be closed after being opened
                if (currentQuestion.answeredByVitalParam !== null) {
                    return;
                }
                this.selectSymptom(currentQuestion);
            }

        },

        methods: {
            handleChangeAnswer (selectedAnswerCode, selectedQuestionCode, answeredByVitalParam, e) {

                if (answeredByVitalParam != null) {
                    this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);
                    this.$store.commit('VitalParametersStore/setFocusVitalParameter', answeredByVitalParam);

                    return;
                }

                const that = this;
                if(this.isActive ||
                    e.target.parentElement.classList.contains('active') ||
                    e.target.classList.contains('active')) {
                    setTimeout(function(){

                        that.$store.dispatch('AssessmentStartStore/submitSpecificQuestionAnswer', {
                            newProvidedAnswerCode: '',
                            questionCode: selectedQuestionCode

                        }).then((response) => { that.$emit('emitChangeAnswer', {questionCode: selectedQuestionCode}); });
                    }, 100)

                } else {

                    setTimeout(function(){

                        that.$store.dispatch('AssessmentStartStore/submitSpecificQuestionAnswer', {
                            newProvidedAnswerCode: selectedAnswerCode,
                            questionCode: selectedQuestionCode

                        }).then((response) => { that.$emit('emitChangeAnswer', {questionCode: selectedQuestionCode}); });

                    }, 100)


                    setTimeout(function() {
                        let responseQuestion = Array.from(document.getElementsByClassName('symptom-response'));

                        if(responseQuestion.length === 1 ) {
                            responseQuestion[0].classList.add('last-item');
                        };

                    }, 1500)

                }

            },

            handleChangeAnswerFromPriorityPage(selectedQuestionCode, selectedAnswerCode, isAnswerAdded, answerList) {

                if (this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode] != null
                    && this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0] != null
                    && this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0].$el != null
                    && this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0].$el.classList != null) {

                    let vBtnAnswerElement = this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0].$el;

                    if (isAnswerAdded === true) {

                        //When make one Answer with class 'active', remove the class from other if exists
                        answerList.forEach((answerItem) => {

                            let answerItemCode = answerItem.code;

                            if (this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode] != null
                                && this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0] != null
                                && this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0].$el != null
                                && this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0].$el.classList != null) {

                                let answerItemElement = this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0].$el;

                                if (answerItemElement.classList.contains('active')) {
                                    answerItemElement.classList.remove('active');
                                }
                            }
                        });

                        vBtnAnswerElement.classList.add('active');
                    }
                    else {
                        vBtnAnswerElement.classList.remove('active');
                    }
                }

                const that = this;
                setTimeout(function() {

                    that.$store.dispatch('AssessmentStartStore/submitSpecificQuestionAnswer', {
                        newProvidedAnswerCode: isAnswerAdded === true ? selectedAnswerCode : '',
                        questionCode: selectedQuestionCode

                    }).then((response) => { that.$emit('emitChangeAnswer', {questionCode: selectedQuestionCode}); });

                }, 100);

                setTimeout(function() {
                    let responseQuestion = Array.from(document.getElementsByClassName('symptom-response'));

                    if(responseQuestion.length === 1 ) {
                        responseQuestion[0].classList.add('last-item');
                    }

                }, 1500);
            },

            selectSymptom(question) {

                this.$store.commit('SymptomsQuestionsStore/setSymptomDescription', question.description);
                this.$store.commit('SymptomsQuestionsStore/setSymptomCode', question.code);
                this.$store.commit('SymptomsQuestionsStore/setSymptomName', question.name);
                this.$store.commit('SymptomsQuestionsStore/setSymptomText', question.text);
                this.$store.commit('SymptomsQuestionsStore/setRelatedSymptomName', question.symptomName);
                this.$store.commit('SymptomsQuestionsStore/setSymptomType', question.type);

                this.$emit('emitQuestionClick', {
                    questionCode: question.code
                });

            }

        },

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .priority-list-page {

        .selected-symptom {
            -webkit-box-shadow: -8px 6px 33px -12px rgba(0, 0, 0, 0.75);
            -moz-box-shadow: -8px 6px 33px -12px rgba(0, 0, 0, 0.75);
            box-shadow: -8px 6px 33px -12px rgba(0, 0, 0, 0.75);
        }

        .question-title {
            font-size: $font-size-default;
            color: #515b60;
        }

        .question-text {
            font-size: 14px;
            color: $color-gray;
        }
    }

</style>





// WEBPACK FOOTER //
// src/professional/components/assessment-start/QuestionsPriorityList.vue